<div class="Error" *ngIf="showErrorMessage">
  <div class="Wrap">
    <div class="Content">
      <div class="Error-container">
        <div class="row">
          <div class="col-lg-9">
            <div class="row">
              <div class="col-md-6">
                <img src="assets/images/error-activation.png">
              </div>
              <div class="col-md-6">
                <div class="Text">
                  <h2>Your account activation failed</h2>
                  <p>
                    Try activating your account again or<br>
                    contact our Helpdesk if problem persists
                  </p>
                  <!-- <h2>Your account activation is in progress</h2>

                  <p>You'll receive a confirmation soon by email</p>-->
                  <a href="mailto:helpdesk@cullen-international.com" class="Button Button--action">Helpdesk</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3"></div>
        </div>
      </div>
    </div>
  </div>
</div>
